export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20overhead%20flat%20lay%20of%20premium%20fashion%20items%20including%20white%20sneakers%20leather%20handbag%20gold%20watch%20and%20sunglasses%20arranged%20on%20dark%20charcoal%20surface%2C%20dramatic%20top%20lighting%20with%20rich%20shadows%2C%20luxury%20editorial%20product%20photography%2C%20high%20contrast%20sophisticated%20composition%2C%20elegant%20aspirational%20lifestyle%20mood%2C%20no%20text%20or%20logos&width=1600&height=600&seq=sugargoo-cta-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet curated fashion finds"
          title="Shop Sugargoo Spreadsheet Finds"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-foreground-900/55"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-6 md:px-10">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-4">
          Ready to Shop Smarter?
        </h2>
        <p className="text-background-200/90 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-8">
          Access the most comprehensive Sugargoo spreadsheet directory. Thousands of curated finds across every category — start browsing now.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="#categories"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse Categories
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}